<template>
  <div id="MainView">
  <section class="main" id="main" :class="{on:classActive}">
    <video class="earth" width="100%" height="auto" src="../../assets/image/earth.mp4" autoplay muted loop></video>
    <h1 class="logo"><a href="#"><img src="../../assets/image/logo_1.png"></a></h1>
    <menu>
      <ul>
        <li :class="{'on' : activeIndex == 0}" @click="viewDescription(0)">
          <img src="../../assets/image/icon_coding_1.png">
          <p data-lang="btn_block_coding">BLOCK CODING</p>
        </li>
        <li :class="{'on' : activeIndex == 1}" @click="viewDescription(1)">
          <img src="../../assets/image/icon_ai_1.png">
          <p data-lang="btn_ai">AI</p>
        </li>
        <li :class="{'on' : activeIndex == 2}" @click="viewDescription(2)">
          <img src="../../assets/image/icon_one.png">
          <p data-lang="btn_contec_one">CONTEC ONE</p>
        </li>
        <li :class="{'on' : activeIndex == 3}" @click="viewDescription(3)">
          <img src="../../assets/image/icon_contec.png">
          <p data-lang="btn_contec">CONTEC.KR</p>
        </li>
      </ul>
    </menu>

    <div class="main_bg">
      <article class="maintext_1" :class="{'on' : activeIndex == 0}">
        <h2 data-lang="title_block_coding">BLOCK CODING</h2>
        <h5 data-lang="sub_title_education">Education Service</h5>
        <div class="mt">
          <p data-lang="text_block_coding">Satellite image is an essential element of the recent society to solve various social issues, which makes it indispensable to give related education for the future generation. Recently, there has been a surge in interest in coding(programming), and satellite image can be assessed as useful content which enhances academic achievement in block coding education. Future generations can be divided into different units to perform each necessary step by combining blocks to identify and classify different types of objects and buildings in the satellite image. By exposing the use of satellite image through easily accessible ways of education which catch the attention of the young generation, the public awareness of space will arise and thus contribute to the training of talented students for the evolving New Space era.</p>
          <div class="btn">
            <a href="https://block.contec.kr" target="_blank"><span><i class="xi-arrow-right"></i>GO</span></a>
          </div>
        </div>
      </article>
      <article class="maintext_2" :class="{'on' : activeIndex == 1}">
        <h2 data-lang="title_ai">AI</h2>
        <h5 data-lang="sub_title_satellite">Satellite Imagery Application</h5>
        <div class="mt">
          <p data-lang="text_satellite">Satellite images collected by Earth Observation satellites are basically used to create a map or build a Geographical Information System. In the past few years, AI deep learning algorithms have been applied to satellite images and generated a valuable data contributing to the development in various industries including fisheries, agriculture, land use, urban planning, etc. In addition, the advancement in technology has not only enabled to collect the data with high revisit rate through the high-resolution satellite constellation, but also allowed the monitoring of and during the physically inaccessible areas and time. In case of a smart city, satellite imagery has solved various urban problems such as obsolescence in cities, traffic congestion, and crime by applying multi-class object detection, semantic segmentation, and time series-based change detection. Economy, for instance, uses satellite image data to track changes in the shadows of oil tanks to predict the oil stocks, and to forecast financial markets by combining satellite images with economic indicators.</p>
<!--          <div class="btn">-->
<!--            <a href="https://ai.contec.kr/" target="_blank"><span><i class="xi-arrow-right"></i>GO</span></a>-->
<!--          </div>-->
        </div>
      </article>
      <article class="maintext_3" :class="{'on' : activeIndex == 2}">
        <h2 data-lang="title_contec_one">CONTEC ONE</h2>
        <div class="mt">
          <p data-lang="text_contec_one">CONTEC ONE is a web-based service platform which enables customers to schedule their passes in one click for our network of ground stations to receive the data. As long as internet connection is secured, customers can use any of our ground stations registered from any place in the world..</p>
          <div class="btn">
            <a href="http://dev-one.contec.kr/" target="_blank"><span><i class="xi-arrow-right"></i>GO</span></a>
          </div>
        </div>
      </article>
      <article class="maintext_4" :class="{'on' : activeIndex == 3}">
        <h2 data-lang="title_contec">CONTEC.KR</h2>
        <div class="mt">
          <p data-lang="text_contec">CONTEC is a specialized space company established to keep up with the emerging “NEW SPACE” age by providing a total solution required downstream. CONTEC builds space ground stations in major domestic/foreign locations to receive data from satellites and launch vehicles, and further pre-process the received data and provide satellite image application services.</p>
          <div class="btn">
            <a href="http://contec.kr/" target="_blank"><span><i class="xi-arrow-right"></i>GO</span></a>
          </div>
        </div>
      </article>
    </div>
    <i class="xi-angle-down-thin down" @click="scrollBtn"></i>
  </section>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "MainView",
  data: ()=> ({
    activeIndex: null,
    myScroll: null,
    classActive: false,
    clickScroll: null
  }),
  props: ['nowScroll'],
  watch: {
    nowScroll(newData) {
      this.textToggle(newData)
    }
  },
  mounted() {
    this.viewDescription(0)
    this.myScroll = $('#MainView').offset().top
    this.clickScroll = $('#MainView').offset().top
  },
  methods: {
    viewDescription(index) {
      this.activeIndex = index
    },
    textToggle(data) {
      if(data >= (this.myScroll + 1400)) {
        this.classActive = true
      } else {
        this.classActive = false
      }
    },
    scrollBtn() {
      this.clickScroll = window.scrollTo({top:500, behavior:'smooth'})
    }
  }
}

</script>

<style scoped>

</style>